import React, { useState, useEffect, useLayoutEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory, useParams } from "react-router-dom";
import { HideGlobalLoading, ShowGlobalLoading, UpdateAppSubHeaderTitle } from "../../redux/actions/UiActions";
import { 
  Container, 
  TopContainer, 
  ProfileImage, 
  Title, 
  ButtonContainer, 
  UserDataContainer, 
  Column, 
  ElementDivider, 
  ButtonSaveContainer,
  SettingsPanel,
  SessionRow,
  SessionInfo,
  SessionDetails,
  ConfigTabsContainer,
  ConfigTabButton
} from './styles/MyConfigurationStyles';
import { BodyText, MediumHeightDivider, SmallHeightDivider, StyledButton, StyledButtonOutlined } from '../../theme/Styles'
import TextInformation from '../../components/TextInformation/TextInformation';
import { 
  Grid, 
  Box, 
  Typography, 
  Divider, 
  Switch, 
  FormControlLabel, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Button,
  Alert 
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import NotificationsIcon from "@mui/icons-material/Notifications";
import BusinessIcon from "@mui/icons-material/Business";
import SecurityIcon from "@mui/icons-material/Security";
import SettingsIcon from "@mui/icons-material/Settings";
import DevicesIcon from "@mui/icons-material/Devices";
import TranslateIcon from "@mui/icons-material/Translate";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import { useFormik } from 'formik';
import TextField from "../../components/TextField/TextField";
import Select from "../../components/Select/Select";
import CheckBox from "../../components/CheckBox/CheckBox";
import { FormEmailSchema, FormPasswordSchema, FormSchema } from "./MyConfigurationConstants";
import apiCall from "../../services/ApiServerCall";
import FormModal from "../../components/FormModal/FormModal";
import { modifyEmail, modifyPassword, modifyUserData } from "../../api/myConfiguration";
import { useSnackbar } from 'notistack';
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { stringToDominicanCedula } from "../../utilities/functions/FormatterUtil";
import { getUser } from "../../api/Auth";
import PhoneTextField from "../../components/PhoneTextField/PhoneTextField";
import { cleanStringFromNumbers } from '../../utilities/functions/NumberUtil';
import LocalStorageService from "../../services/LocalStorageService";
import { SweetAlert } from "../../components/SweetAlert/SweetAlert";
import { removeLocalStorageSessionData } from "../../auth/AuthFunctions";
import Skeleton from "@mui/material/Skeleton";
import { ROLE_TYPE } from "../../constants/constants";
import MyProfile from "../MyDesk/subViews/myProfile/MyProfile";

const DelegationsTable = ({ delegations, darkMode, setDelegations, enqueueSnackbar }) => (
  <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #E2E8F0', borderRadius: '12px', overflow: 'hidden' }}>
    <Table sx={{ minWidth: 600 }}>
      <TableHead sx={{ bgcolor: 'rgba(3, 13, 57, 0.05)' }}>
        <TableRow>
          <TableCell sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>Nombre</TableCell>
          <TableCell sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>Documento</TableCell>
          <TableCell sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>Empresa</TableCell>
          <TableCell sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>Permisos</TableCell>
          <TableCell align="right" sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>Acciones</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {delegations.map((row) => (
          <TableRow key={row.id}>
            <TableCell sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 600 }}>{row.name}</TableCell>
            <TableCell sx={{ fontFamily: 'Roboto, sans-serif' }}>{row.citizenId}</TableCell>
            <TableCell sx={{ fontFamily: 'Roboto, sans-serif' }}>{row.company}</TableCell>
            <TableCell sx={{ fontFamily: 'Roboto, sans-serif' }}>
              <Box sx={{
                display: 'inline-flex', px: 1.5, py: 0.5, borderRadius: '12px', fontSize: '11px', fontWeight: 700,
                bgcolor: row.role === 'Administrador de Trámites' ? '#e7eeff' : '#f1f5f9',
                color: row.role === 'Administrador de Trámites' ? '#192873' : '#475569'
              }}>
                {row.role}
              </Box>
            </TableCell>
            <TableCell align="right">
              <Button
                size="small"
                color="error"
                onClick={() => {
                  setDelegations(delegations.filter(d => d.id !== row.id));
                  enqueueSnackbar(`Autorización revocada para ${row.name}`, { variant: 'info' });
                }}
                sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 'bold' }}
              >
                Revocar
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

// Componente de Configuración del usuario
export const MyConfiguration = () => {

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();
  const location = useLocation();
  const history = useHistory();

  const { tab } = useParams();

  const { rolBase } = useSelector((state) => state.authReducer);

  const [userImage, setUserImage] = useState("");

  const [provincesData, setProvincesData] = useState([]);
  const [municipalitiesData, setMunicipalitiesData] = useState([]);
  const [sectorsData, setSectorsData] = useState([]);

  const [openModifyPasswordModal, setOpenModifyPasswordModal] = useState(false);
  const [openModifyEmailModal, setOpenModifyEmailModal] = useState(false);

  // New features state
  const [activeTab, setActiveTab] = useState('perfil');
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [openOtpModal, setOpenOtpModal] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otpError, setOtpError] = useState('');
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const [language, setLanguage] = useState(LocalStorageService.getItem('language') || 'es');
  const [darkMode, setDarkMode] = useState(LocalStorageService.getItem('dark_mode') === 'true');
  const [notifFrequency, setNotifFrequency] = useState('instant');
  const [emailNotif, setEmailNotif] = useState(true);
  const [legalAlerts, setLegalAlerts] = useState(true);

  const [delegations, setDelegations] = useState([
    { id: 1, name: 'Lic. Juan Pérez', citizenId: '001-1892837-2', company: 'Inversiones Turísticas SAS', role: 'Administrador de Trámites' },
    { id: 2, name: 'Dra. María Almonte', citizenId: '002-0982736-4', company: 'Hoteles del Este SRL', role: 'Solo Consulta' }
  ]);
  const [delName, setDelName] = useState('');
  const [delCitizenId, setDelCitizenId] = useState('');
  const [delCompany, setDelCompany] = useState('Hoteles del Este SRL');
  const [delRole, setDelRole] = useState('Administrador de Trámites');

  const [activeSessions, setActiveSessions] = useState([
    { id: 'session-1', browser: 'Google Chrome', os: 'Windows 11', ip: '186.6.124.90', location: 'Santo Domingo, RD', current: true, date: 'Activo ahora' },
    { id: 'session-2', browser: 'Safari', os: 'Apple iOS (iPhone)', ip: '186.6.15.22', location: 'Santiago, RD', current: false, date: 'Hace 2 horas' },
    { id: 'session-3', browser: 'Mozilla Firefox', os: 'macOS Ventura', ip: '190.166.44.8', location: 'Santo Domingo, RD', current: false, date: 'Hace 3 días' }
  ]);

  const { isLoading, error, data, isFetching } = useQuery(['userData'], () => getUser());
  const mutation = useMutation(modifyUserData);

  const userPayload = (data && data.payload) ? data.payload : {};

  const formik = useFormik({
    initialValues: {
      address: userPayload.address || '',
      province_id: userPayload.province_id || '',
      municipality_id: userPayload.municipality_id || '',
      sector_id: userPayload.sector_id || '',
      phone: userPayload.phone || '',
      phone2: userPayload.phone2 || '',
      notificationsWithEmail: false,
      notificationsSms: false
    },
    validationSchema: FormSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      handleModifyUserData(values);
    },
  });

  const formikPasswordChange = useFormik({
    initialValues: {
      old_password: '',
      password: '',
      new_password_confirmation: ''
    },
    validationSchema: FormPasswordSchema,
    onSubmit: (values) => {
      handleModifyPassword(values);
    },
  });

  const formikEmailChange = useFormik({
    initialValues: {
      password: '',
      email: '',
      new_email_confirmation: ''
    },
    validationSchema: FormEmailSchema,
    onSubmit: (values) => {
      handleModifyEmail(values);
    },
  });

  useLayoutEffect(() => {
    setUserImage(LocalStorageService.getItem('profile_img'));
    dispatch(UpdateAppSubHeaderTitle("Mi cuenta"));

    // Initialize dark mode
    const isDark = LocalStorageService.getItem('dark_mode') === 'true';
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [dispatch]);

  useEffect(() => {
    if (location.state?.openPasswordModal) {
      setActiveTab('seguridad');
      setOpenModifyPasswordModal(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (tab) {
      if (tab === 'sistema') {
        setActiveTab('configuracion');
      } else {
        setActiveTab(tab);
      }
    } else {
      setActiveTab('perfil');
    }
  }, [tab]);

  useEffect(() => {
    if (data && data.payload) {
      const userId = data.payload.citizen_id;
      const local2FA = LocalStorageService.getItem(`two_factor_enabled_${userId}`) === 'true';
      const tf = data.payload.two_factor || data.payload.two_factor_enabled;
      const backend2FA = tf === true || tf === 1 || tf === 'true' || tf === '1';
      setTwoFactorEnabled(backend2FA || local2FA);
    }
  }, [data]);

  useEffect(() => {
    (async () => {
      await getProvincesData();
      if (data && data.payload) {
        await getMunicipalitiesData(data.payload.province_id);
        await getSectorsData(data.payload.municipality_id);
      }
    })();
  }, [data]);

  const handleDarkModeToggle = (enabled) => {
    setDarkMode(enabled);
    LocalStorageService.setItem('dark_mode', String(enabled));
    if (enabled) {
      document.documentElement.classList.add('dark');
      enqueueSnackbar('Modo oscuro activado', { variant: 'info' });
    } else {
      document.documentElement.classList.remove('dark');
      enqueueSnackbar('Modo claro activado', { variant: 'info' });
    }
  };

  const handleModifyPasswordModal = () => {
    formikPasswordChange.resetForm();
    setOpenModifyPasswordModal(!openModifyPasswordModal);
  }
  
  const handleModifyEmailModal = () => {
    formikEmailChange.resetForm();
    setOpenModifyEmailModal(!openModifyEmailModal);
  }

  const handleModifyPassword = async (formData) => {
    try {
      const response = await modifyPassword(formData);
      if (response.data.success) {
        enqueueSnackbar('Se ha modificado su contraseña', { variant: 'success' });
        handleModifyPasswordModal();
      } else {
        enqueueSnackbar(response.data.msg, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar("Ha sucedido un error intentelo mas tarde", { variant: 'error' });
    }
  }

  const handleModifyEmail = async (formData) => {
    try {
      dispatch(ShowGlobalLoading('Cargando'))
      const response = await modifyEmail(formData);
      if (response.data.success) {
        handleModifyEmailModal();
        SweetAlert.fire({
          title: "Email modificado satisfactoriamente",
          text: "Inicie sesión nuevamente",
          icon: 'warning',
          confirmButtonText: 'Ok'
        })
        setTimeout(() => {
          removeLocalStorageSessionData();
          window.location.reload();
        }, 2500);
      } else {
        enqueueSnackbar(response.data.msg, { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar("Ha sucedido un error intentelo mas tarde", { variant: 'error' });
    } finally {
      dispatch(HideGlobalLoading())
    }
  }

  const handleModifyUserData = async (formData) => {
    const request = {
      phone: formData.phone,
      phone2: formData.phone2,
      province_id: formData.province_id,
      municipality_id: formData.municipality_id,
      sector_id: formData.sector_id,
      address: formData.address,
    }
    mutation.mutate(request, {
      onSuccess: (data) => {
        if (data.data.success) {
          queryClient.invalidateQueries('userData')
          enqueueSnackbar('Se ha modificado su información de usuario', { variant: 'success' });
        } else {
          enqueueSnackbar(data.data.msg || "Ha ocurrido un error", { variant: 'error' });
        }
        dispatch(HideGlobalLoading())
      }
    })
  }

  const handleTwoFactorToggle = async (checked) => {
    if (checked) {
      setOtpCode('');
      setOtpSent(false);
      setOtpError('');
      setOpenOtpModal(true);
    } else {
      const userId = data?.payload?.citizen_id;
      if (userId) {
        LocalStorageService.setItem(`two_factor_enabled_${userId}`, 'false');
      }
      setTwoFactorEnabled(false);
      try {
        await modifyUserData({
          ...formik.values,
          two_factor: false,
          two_factor_enabled: false
        });
        queryClient.invalidateQueries('userData');
      } catch (err) {
        // ignore
      }
      enqueueSnackbar('Autenticación de Doble Factor (2FA) desactivada', { variant: 'info' });
    }
  };

  const handleSendOtp = async () => {
    const email = data?.payload?.email;
    if (!email) {
      setOtpError('No se encontró el correo del usuario.');
      return;
    }
    setIsSendingOtp(true);
    setOtpError('');
    try {
      await apiCall().post('/otp/send');
      setOtpSent(true);
      enqueueSnackbar('Código OTP enviado a su correo', { variant: 'success' });
    } catch (error) {
      setOtpError('Error al enviar el código OTP. Inténtelo de nuevo.');
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    const email = data?.payload?.email;
    const userId = data?.payload?.citizen_id;
    if (!email || !otpCode) {
      setOtpError('Por favor complete todos los campos.');
      return;
    }
    setIsVerifyingOtp(true);
    setOtpError('');
    try {
      const { data: otpResponse } = await apiCall().post('/otp/verify', { code: otpCode });
      if (otpResponse?.success) {
        if (userId) {
          LocalStorageService.setItem(`two_factor_enabled_${userId}`, 'true');
        }
        setTwoFactorEnabled(true);
        setOpenOtpModal(false);
        enqueueSnackbar('Autenticación de Doble Factor (2FA) activada con éxito', { variant: 'success' });
        try {
          await modifyUserData({
            ...formik.values,
            two_factor: true,
            two_factor_enabled: true
          });
          queryClient.invalidateQueries('userData');
        } catch (err) {
          // ignore
        }
      } else {
        setOtpError(otpResponse?.msg || 'Código OTP inválido.');
      }
    } catch (error) {
      setOtpError(error.response?.data?.msg || 'Código OTP inválido o expirado.');
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const getProvincesData = async () => {
    try {
      let provincesData = await apiCall().get('/get/provinces')
      if (provincesData) {
        setProvincesData(
          provincesData.data.provinces?.map((province) => ({
            value: province.bidclasif,
            label: province.ctituloclas
          })));
      }
      setMunicipalitiesData([]);
      setSectorsData([]);
    } catch (error) {
      // Handle error
    }
  }

  const getMunicipalitiesData = async (value) => {
    try {
      let municipalitiesData = await apiCall().get(`/get/municipalities/${value}`)
      if (municipalitiesData.data.success) {
        setMunicipalitiesData(
          municipalitiesData.data.municipalities?.map((municipalities) => ({
            value: municipalities.bidclasif,
            label: municipalities.ctituloclas
          })));
      }
      setSectorsData([]);
    } catch (error) {
      // Handle error
    }
  }

  const getSectorsData = async (value) => {
    try {
      let sectorsData = await apiCall().get(`/get/sectors/${value}`)
      if (sectorsData.data.success) {
        setSectorsData(
          sectorsData.data.sectors?.map((sector) => ({
            value: sector.bidclasif,
            label: sector.ctituloclas
          })));
      }
    } catch (error) {
      // Handle error
    }
  }

  const handleTabChange = (tabName) => {
    history.push(`/app/mi-cuenta/${tabName}`);
  };

  return isLoading ? (
    <Container>
      <SettingsPanel style={{ marginTop: '24px' }}>
        <ConfigTabsContainer>
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton key={i} variant="rectangular" width={120} height={40} style={{ borderRadius: '8px', marginRight: '8px' }} />
          ))}
        </ConfigTabsContainer>
        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', mb: 4 }}>
          <Skeleton variant="circular" width={100} height={100} />
          <Box>
            <Skeleton variant="text" width={250} height={32} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
        </Box>
        <Divider sx={{ mb: 4 }} />
        <Grid container spacing={3}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Grid item xs={12} sm={6} key={i}>
              <Skeleton variant="rectangular" height={56} style={{ borderRadius: '8px' }} />
            </Grid>
          ))}
        </Grid>
      </SettingsPanel>
    </Container>
  ) : (
    <Container>
      <SettingsPanel style={{ marginTop: '24px' }}>
        <ConfigTabsContainer>
          <ConfigTabButton active={activeTab === 'perfil'} onClick={() => handleTabChange('perfil')}>
            <PersonIcon />
            <span>{language === 'en' ? 'My Profile' : 'Mi Perfil'}</span>
          </ConfigTabButton>
          {activeTab === 'contacto' && (
            <ConfigTabButton active={activeTab === 'contacto'} onClick={() => handleTabChange('contacto')}>
              <PersonIcon />
              <span>{language === 'en' ? 'Edit Profile' : 'Editar perfil'}</span>
            </ConfigTabButton>
          )}
          <ConfigTabButton active={activeTab === 'notificaciones'} onClick={() => handleTabChange('notificaciones')}>
            <NotificationsIcon />
            <span>{language === 'en' ? 'Notifications' : 'Notificaciones'}</span>
          </ConfigTabButton>
          {rolBase === ROLE_TYPE.COMPANY && (
            <ConfigTabButton active={activeTab === 'delegacion'} onClick={() => handleTabChange('delegacion')}>
              <BusinessIcon />
              <span>{language === 'en' ? 'Delegation' : 'Delegación'}</span>
            </ConfigTabButton>
          )}
          <ConfigTabButton active={activeTab === 'seguridad'} onClick={() => handleTabChange('seguridad')}>
            <SecurityIcon />
            <span>{language === 'en' ? 'Security & Sessions' : 'Seguridad y Sesiones'}</span>
          </ConfigTabButton>
          <ConfigTabButton active={activeTab === 'configuracion'} onClick={() => handleTabChange('configuracion')}>
            <SettingsIcon />
            <span>{language === 'en' ? 'Settings' : 'Configuración'}</span>
          </ConfigTabButton>
        </ConfigTabsContainer>
        {/* Tab -1: Mi Perfil */}
        {activeTab === 'perfil' && (
          <div style={{ padding: "8px 0" }}>
            <MyProfile rolBase={rolBase} />
          </div>
        )}

        {/* Tab 0: Datos de Contacto */}
          {activeTab === 'contacto' && (
            <div>
              <TopContainer style={{ marginBottom: '16px' }}>
                <UserDataContainer>
                  <ProfileImage src={userImage} />
                  <div>
                    <Title>{data && data.payload.name + " " + data.payload.first_last_name + " " + data.payload.second_last_name}</Title>
                    <BodyText>Cédula: <strong>{data && stringToDominicanCedula(data.payload.citizen_id)}</strong></BodyText>
                  </div>
                </UserDataContainer>
              </TopContainer>
              <Divider sx={{ mb: 4 }} />
              <TextInformation title="Datos de localización y contacto" />
              <SmallHeightDivider />
              <SmallHeightDivider />

              <Grid alignItems="center" justifyContent="center" container direction="row" spacing={{ xs: 2, md: 3 }} columns={{ xs: 8, sm: 8, md: 12 }}>
                <Grid item xs={8} sm={4} md={6}>
                  <TextField title="Dirección" type="text" id="address"
                    required
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>

                <Grid item xs={8} sm={4} md={6}>
                  <Select title="Provincia" type="text" id="province_id"
                    data={provincesData}
                    value={formik.values.province_id}
                    onChange={(e) => {
                      formik.setFieldValue('municipality_id', '');
                      formik.setFieldValue('sector_id', '');
                      formik.handleChange(e);
                      getMunicipalitiesData(e.target.value)
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.province_id && Boolean(formik.errors.province_id)}
                    helperText={formik.touched.province_id && formik.errors.province_id}
                    required
                  />
                </Grid>

                <Grid item xs={8} sm={4} md={6}>
                  <Select title="Municipio" type="text" id="municipality_id"
                    disabled={formik.values['province_id'].length <= 0}
                    data={municipalitiesData}
                    value={formik.values.municipality_id}
                    onChange={(e) => {
                      formik.setFieldValue('sector_id', '');
                      formik.handleChange(e);
                      getSectorsData(e.target.value);
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.municipality_id && Boolean(formik.errors.municipality_id)}
                    helperText={formik.touched.municipality_id && formik.errors.municipality_id}
                    required
                  />
                </Grid>

                <Grid item xs={8} sm={4} md={6}>
                  <Select title="Sector" type="text" id="sector_id"
                    disabled={formik.values['municipality_id'].length <= 0}
                    data={sectorsData}
                    value={formik.values.sector_id}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.sector_id && Boolean(formik.errors.sector_id)}
                    helperText={formik.touched.sector_id && formik.errors.sector_id}
                    required
                  />
                </Grid>

                <Grid item xs={8} sm={4} md={6}>
                  <PhoneTextField title="Teléfono móvil" type="text" id="phone"
                    required
                    value={cleanStringFromNumbers(formik.values.phone)}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.phone && Boolean(formik.errors.phone)}
                    helperText={formik.touched.phone && formik.errors.phone}
                  />
                </Grid>

                <Grid item xs={8} sm={4} md={6}>
                  <PhoneTextField title="Teléfono secundario" type="text" id="phone2"
                    required
                    value={cleanStringFromNumbers(formik.values.phone2)}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.phone2 && Boolean(formik.errors.phone2)}
                    helperText={formik.touched.phone2 && formik.errors.phone2}
                  />
                </Grid>
              </Grid>
              
              <MediumHeightDivider />
              <ButtonSaveContainer>
                <StyledButtonOutlined variant="outlined" onClick={formik.handleSubmit}>Guardar Cambios</StyledButtonOutlined>
              </ButtonSaveContainer>
            </div>
          )}

          {/* Tab 1: Preferencias de Notificaciones */}
          {activeTab === 'notificaciones' && (
            <div>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' ? 'Notification Preferences' : 'Preferencias de Notificaciones'}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' 
                  ? 'Configure the communication channels and frequency to receive official UCTT notices.' 
                  : 'Configure los canales y la frecuencia con la que desea recibir avisos sobre sus trámites oficiales de la UCTT.'}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                    {language === 'en' ? 'Communication Channels' : 'Canales de Comunicación'}
                  </Typography>
                  <FormControlLabel
                    control={<Switch checked={emailNotif} onChange={(e) => setEmailNotif(e.target.checked)} color="primary" />}
                    label={
                      <Box sx={{ ml: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>
                          {language === 'en' ? 'Email Notifications' : 'Correo Electrónico'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Roboto, sans-serif' }}>
                          {language === 'en' ? 'Receive automatic status alerts in your primary inbox' : 'Recibir alertas automáticas de estado en tu correo principal'}
                        </Typography>
                      </Box>
                    }
                    sx={{ mb: 2, alignItems: 'flex-start' }}
                  />
                </Box>

                <Divider />

                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif' }}>
                    {language === 'en' ? 'Notification Frequency' : 'Frecuencia de Notificación'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                    {language === 'en' 
                      ? 'How frequently would you like to receive updates on your active applications?' 
                      : '¿Con qué periodicidad desea recibir actualizaciones de sus trámites en curso?'}
                  </Typography>
                  <Select 
                    title={language === 'en' ? "Delivery Frequency" : "Frecuencia de envío"} 
                    id="notif_frequency"
                    data={language === 'en' ? [
                      { value: 'instant', label: 'Instant (Recommended - On status change)' },
                      { value: 'daily', label: 'Daily Summary' },
                      { value: 'weekly', label: 'Weekly Summary' }
                    ] : [
                      { value: 'instant', label: 'Instantáneo (Recomendado - Cada cambio de estado)' },
                      { value: 'daily', label: 'Resumen Diario' },
                      { value: 'weekly', label: 'Resumen Semanal' }
                    ]}
                    value={notifFrequency}
                    onChange={(e) => setNotifFrequency(e.target.value)}
                  />
                </Box>

                <Divider />

                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                    {language === 'en' ? 'Legal Base Subscriptions' : 'Suscripciones a Base Legal'}
                  </Typography>
                  <FormControlLabel
                    control={<Switch checked={legalAlerts} onChange={(e) => setLegalAlerts(e.target.checked)} color="primary" />}
                    label={
                      <Box sx={{ ml: 1 }}>
                        <Typography variant="body1" sx={{ fontWeight: 600, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>
                          {language === 'en' ? 'New Regulation Alerts' : 'Alertas de Nuevas Regulaciones'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Roboto, sans-serif' }}>
                          {language === 'en'
                            ? 'Receive instant notice when new UCTT laws, decrees, or resolutions are published'
                            : 'Recibe un aviso inmediato al publicarse nuevas Leyes, Decretos o Resoluciones de la UCTT'}
                        </Typography>
                      </Box>
                    }
                    sx={{ alignItems: 'flex-start' }}
                  />
                </Box>

                <MediumHeightDivider />
                <ButtonSaveContainer>
                  <StyledButtonOutlined variant="outlined" onClick={() => {
                    enqueueSnackbar(
                      language === 'en'
                        ? 'Notification preferences saved successfully'
                        : 'Preferencias de notificación guardadas correctamente',
                      { variant: 'success' }
                    );
                  }}>
                    {language === 'en' ? 'Save Preferences' : 'Guardar Preferencias'}
                  </StyledButtonOutlined>
                </ButtonSaveContainer>
              </Box>
            </div>
          )}

          {/* Tab 2: Gestión de Representación y Delegación */}
          {activeTab === 'delegacion' && (
            <div>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif' }}>
                Gestión de Representación y Delegación
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontFamily: 'Roboto, sans-serif' }}>
                Delegue de forma segura el acceso a sus trámites corporativos introduciendo el documento de identidad de su gestor autorizado.
              </Typography>

              <Box sx={{ bgcolor: '#F8F9FD', border: '1px solid #E2E8F0', borderRadius: '12px', p: 3, mb: 4 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                  Autorizar Nuevo Gestor / Delegado
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField 
                      title="Cédula del Delegado" 
                      type="text" 
                      id="del_citizen_id"
                      mask="999-9999999-9"
                      value={delCitizenId}
                      onChange={(e) => setDelCitizenId(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <TextField 
                      title="Nombre del Gestor" 
                      type="text" 
                      id="del_name"
                      value={delName}
                      onChange={(e) => setDelName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Select 
                      title="Empresa asociada" 
                      id="del_company"
                      value={delCompany}
                      onChange={(e) => setDelCompany(e.target.value)}
                      data={[
                        { value: 'Hoteles del Este SRL', label: 'Hoteles del Este SRL' },
                        { value: 'Inversiones Turísticas SAS', label: 'Inversiones Turísticas SAS' }
                      ]}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    <Select 
                      title="Rol / Permisos" 
                      id="del_role"
                      value={delRole}
                      onChange={(e) => setDelRole(e.target.value)}
                      data={[
                        { value: 'Administrador de Trámites', label: 'Administrador (Completo)' },
                        { value: 'Solo Consulta', label: 'Solo Consulta (Lectura)' }
                      ]}
                    />
                  </Grid>
                </Grid>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={() => {
                      if (!delCitizenId || !delName || !delCompany) {
                        enqueueSnackbar('Por favor complete la Cédula, Nombre y Empresa del delegado', { variant: 'warning' });
                        return;
                      }
                      const newDel = {
                        id: Date.now(),
                        name: delName,
                        citizenId: delCitizenId,
                        company: delCompany,
                        role: delRole
                      };
                      setDelegations([...delegations, newDel]);
                      setDelName('');
                      setDelCitizenId('');
                      enqueueSnackbar(`Se ha delegado el acceso a ${delName} exitosamente`, { variant: 'success' });
                    }}
                    sx={{
                      bgcolor: darkMode ? '#ffffff' : '#192873',
                      fontFamily: 'Roboto, sans-serif',
                      fontWeight: 'bold',
                      borderRadius: '8px',
                      textTransform: 'uppercase',
                      color: '#ffffff',
                      px: 3,
                      py: 1,
                      '&:hover': { bgcolor: '#1a234e' }
                    }}
                  >
                    Agregar Delegación
                  </Button>
                </Box>
              </Box>

              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                Delegaciones Activas
              </Typography>
              <DelegationsTable
                delegations={delegations}
                darkMode={darkMode}
                setDelegations={setDelegations}
                enqueueSnackbar={enqueueSnackbar}
              />
            </div>
          )}

          {/* Tab 3: Seguridad y Sesiones */}
          {activeTab === 'seguridad' && (
            <div>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' ? 'Advanced Security & Session Management' : 'Seguridad Avanzada y Gestión de Sesiones'}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en'
                  ? 'Manage your institutional account security, configure two-factor authentication, and monitor active devices.'
                  : 'Administre la seguridad de su cuenta institucional, configure el doble factor y supervise los dispositivos activos.'}
              </Typography>

              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' ? 'Access Credentials' : 'Credenciales de Acceso'}
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 4, flexWrap: 'wrap' }}>
                <StyledButtonOutlined variant="outlined" onClick={handleModifyPasswordModal} sx={{ width: 'auto' }}>
                  {language === 'en' ? 'Change Password' : 'Cambiar Contraseña'}
                </StyledButtonOutlined>
                <StyledButtonOutlined variant="outlined" onClick={handleModifyEmailModal} sx={{ width: 'auto' }}>
                  {language === 'en' ? 'Change Main Email' : 'Cambiar Correo Principal'}
                </StyledButtonOutlined>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ mb: 4 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                  {language === 'en' ? 'Two-Factor Authentication (2FA)' : 'Autenticación de Doble Factor (2FA)'}
                </Typography>
                <FormControlLabel
                  control={<Switch checked={twoFactorEnabled} onChange={(e) => handleTwoFactorToggle(e.target.checked)} color="primary" />}
                  label={
                    <Box sx={{ ml: 1 }}>
                      <Typography variant="body1" sx={{ fontWeight: 600, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>
                        {language === 'en' ? 'Enable 2FA via Email' : 'Habilitar 2FA mediante Correo Electrónico'}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Roboto, sans-serif' }}>
                        {language === 'en' 
                          ? 'A unique OTP code will be requested on each login attempt'
                          : 'Se solicitará un código OTP único en cada intento de inicio de sesión'}
                      </Typography>
                    </Box>
                  }
                  sx={{ alignItems: 'flex-start' }}
                />
              </Box>
              {/* Ocultado temporalmente por solicitud del usuario */}
              {/* 
              <Divider sx={{ my: 3 }} />

              <Box>
                <Alert 
                  severity="info" 
                  icon={<InfoIcon />}
                  sx={{ 
                    mb: 3, 
                    borderRadius: '12px', 
                    fontFamily: 'Roboto, sans-serif',
                    border: '1px solid #c7d2fe',
                    backgroundColor: '#e0e7ff',
                    color: '#3730a3',
                    '& .MuiAlert-icon': { color: '#4f46e5' }
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
                    {language === 'en' ? 'Note for Backend Team: Active Session Management' : 'Nota para el Equipo de Backend: Gestión de Sesiones Activas'}
                  </Typography>
                  <Typography variant="body2">
                    {language === 'en'
                      ? 'To enable real session tracking, API integration is required:'
                      : 'Para habilitar el rastreo de sesiones reales, se requiere integrar la API:'}
                    <br />
                    1. <strong>GET /api/v1/auth/sessions</strong>: {language === 'en' ? 'Returns active session list (IP, User-Agent, Last activity date).' : 'Devuelve la lista de sesiones activas (IP, User-Agent, Fecha de última actividad).'}
                    <br />
                    2. <strong>DELETE /api/v1/auth/sessions/others</strong>: {language === 'en' ? 'Revokes all active user tokens except current.' : 'Revoca todos los tokens activos del usuario excepto el actual.'}
                    <br />
                    3. <strong>DELETE /api/v1/auth/sessions/{"{sessionId}"}</strong>: {language === 'en' ? 'Terminates a specific session.' : 'Cierra una sesión específica.'}
                  </Typography>
                </Alert>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3, flexWrap: 'wrap', gap: 2 }}>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 0.5, fontFamily: 'Roboto, sans-serif' }}>
                      {language === 'en' ? 'Active Devices & Sessions' : 'Dispositivos y Sesiones Activas'}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Roboto, sans-serif' }}>
                      {language === 'en' 
                        ? 'List of devices with open sessions on your citizen account.'
                        : 'Lista de dispositivos que tienen sesiones abiertas en su cuenta de ciudadano.'}
                    </Typography>
                  </Box>
                  {activeSessions.length > 1 && (
                    <Button 
                      variant="outlined" 
                      color="error" 
                      size="small"
                      onClick={() => {
                        setActiveSessions(activeSessions.filter(s => s.current));
                        enqueueSnackbar(language === 'en' ? 'All other active sessions have been logged out' : 'Se han cerrado todas las otras sesiones activas', { variant: 'success' });
                      }}
                      sx={{ fontFamily: 'Roboto, sans-serif', fontWeight: 'bold', borderRadius: '8px' }}
                    >
                      {language === 'en' ? 'Log Out Other Sessions' : 'Cerrar Otras Sesiones'}
                    </Button>
                  )}
                </Box>

                {activeSessions.map((session) => (
                  <SessionRow key={session.id}>
                    <SessionInfo>
                      <DevicesIcon sx={{ color: session.current ? (darkMode ? '#ffffff' : '#192873') : (darkMode ? '#94a3b8' : '#767680'), fontSize: '28px' }} />
                      <SessionDetails>
                        <Typography variant="body1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif', display: 'flex', alignItems: 'center', gap: 1 }}>
                          {session.browser} {language === 'en' ? 'on' : 'en'} {session.os}
                          {session.current && (
                            <Box sx={{ display: 'inline-flex', px: 1, py: 0.2, bgcolor: '#e8f5e9', color: '#2e7d32', borderRadius: '4px', fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase' }}>
                              {language === 'en' ? 'This session' : 'Esta sesión'}
                            </Box>
                          )}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '12px', fontFamily: 'Roboto, sans-serif' }}>
                          {language === 'en' ? 'IP Address:' : 'Dirección IP:'} {session.ip} • {language === 'en' ? 'Location:' : 'Ubicación:'} {session.location}
                        </Typography>
                      </SessionDetails>
                    </SessionInfo>
                    <Typography variant="caption" sx={{ color: darkMode ? '#94a3b8' : '#767680', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '10px', fontFamily: 'Roboto, sans-serif' }}>
                      {language === 'en'
                        ? (session.date === 'Activo ahora' ? 'Active now' : session.date === 'Hace 2 horas' ? '2 hours ago' : session.date === 'Hace 3 días' ? '3 days ago' : session.date)
                        : session.date}
                    </Typography>
                  </SessionRow>
                ))}
              </Box>
              */}
            </div>
          )}

          {/* Tab 4: Preferencias del Sistema */}
          {activeTab === 'configuracion' && (
            <div>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' ? 'System Preferences & Language' : 'Preferencias del Sistema e Idioma'}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 4, fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' 
                  ? 'Customize your viewing experience and the language of portal guides and forms.'
                  : 'Personalice su experiencia de visualización y el idioma de los formularios del portal.'}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif', display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TranslateIcon sx={{ fontSize: '20px', color: darkMode ? '#94a3b8' : '#767680' }} />
                    {language === 'en' ? 'Platform Language' : 'Idioma de la Plataforma'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                    {language === 'en'
                      ? 'Select the primary language in which procedures, guides, and portal forms will be presented.'
                      : 'Seleccione el idioma en el que desea que se presenten las guías de trámites y solicitudes.'}
                  </Typography>
                  <Select 
                    title={language === 'en' ? "Primary Language" : "Idioma principal"} 
                    id="system_language"
                    value={language}
                    onChange={(e) => {
                      const selectedLang = e.target.value;
                      setLanguage(selectedLang);
                      LocalStorageService.setItem('language', selectedLang);
                      enqueueSnackbar(
                        selectedLang === 'en'
                          ? 'Language updated to: English (United States)'
                          : 'Idioma cambiado a: Español (Dominicana)',
                        { variant: 'success' }
                      );
                      window.dispatchEvent(new CustomEvent('languageChange', { detail: selectedLang }));
                    }}
                    data={[
                      { value: 'es', label: 'Español (Dominicana)' },
                      { value: 'en', label: 'English (United States)' }
                    ]}
                  />
                </Box>

                <Divider />

                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', mb: 1, fontFamily: 'Roboto, sans-serif', display: 'flex', alignItems: 'center', gap: 1 }}>
                    {darkMode ? <DarkModeIcon sx={{ fontSize: '20px', color: '#eab308' }} /> : <LightModeIcon sx={{ fontSize: '20px', color: darkMode ? '#ffffff' : '#192873' }} />}
                    {language === 'en' ? 'Visual Appearance' : 'Apariencia Visual'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontFamily: 'Roboto, sans-serif' }}>
                    {language === 'en'
                      ? 'Enable dark mode to reduce eye strain in low-light environments.'
                      : 'Active el modo oscuro para reducir la fatiga visual en entornos de poca luz.'}
                  </Typography>
                  <FormControlLabel
                    control={<Switch checked={darkMode} onChange={(e) => handleDarkModeToggle(e.target.checked)} color="primary" />}
                    label={
                      <Typography variant="body1" sx={{ fontWeight: 600, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>
                        {language === 'en' ? 'Dark Mode (Beta)' : 'Modo Oscuro (Beta)'}
                      </Typography>
                    }
                  />
                </Box>
              </Box>
            </div>
          )}
      </SettingsPanel>

      {/* Modals for changing password/email */}
      <FormModal onClose={handleModifyPasswordModal} open={openModifyPasswordModal} title={language === 'en' ? 'Change Password' : 'Modificar Contraseña'} maxWidth="xs" fullWidth>
        <Box sx={{ pt: 1, pb: 2 }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2, 
            mb: 3, 
            p: 2, 
            borderRadius: '12px', 
            bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : '#F8FAFC', 
            border: '1px solid #E2E8F0' 
          }}>
            <Box sx={{ 
              width: 44, 
              height: 44, 
              borderRadius: '10px', 
              bgcolor: 'rgba(32, 42, 93, 0.08)', 
              color: '#192873', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}>
              <VpnKeyIcon sx={{ fontSize: 24 }} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' ? 'Update Security Credentials' : 'Actualización de Contraseña'}
              </Typography>
              <Typography variant="caption" sx={{ color: '#64748B', fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' 
                  ? 'Enter your current password and set a new secure password.' 
                  : 'Ingrese su contraseña actual y configure la nueva clave de acceso.'}
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <TextField 
                title={language === 'en' ? 'Current Password' : 'Contraseña Actual'} 
                type="password" 
                id="old_password"
                value={formikPasswordChange.values.old_password}
                onChange={formikPasswordChange.handleChange}
                onBlur={formikPasswordChange.handleBlur}
                error={formikPasswordChange.touched.old_password && Boolean(formikPasswordChange.errors.old_password)}
                helperText={formikPasswordChange.touched.old_password && formikPasswordChange.errors.old_password}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                title={language === 'en' ? 'New Password' : 'Nueva Contraseña'} 
                type="password" 
                id="password"
                value={formikPasswordChange.values.password}
                onChange={formikPasswordChange.handleChange}
                onBlur={formikPasswordChange.handleBlur}
                error={formikPasswordChange.touched.password && Boolean(formikPasswordChange.errors.password)}
                helperText={formikPasswordChange.touched.password && formikPasswordChange.errors.password}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                title={language === 'en' ? 'Confirm New Password' : 'Repetir Nueva Contraseña'} 
                type="password" 
                id="new_password_confirmation"
                value={formikPasswordChange.values.new_password_confirmation}
                onChange={formikPasswordChange.handleChange}
                onBlur={formikPasswordChange.handleBlur}
                error={formikPasswordChange.touched.new_password_confirmation && Boolean(formikPasswordChange.errors.new_password_confirmation)}
                helperText={formikPasswordChange.touched.new_password_confirmation && formikPasswordChange.errors.new_password_confirmation}
                required
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => formikPasswordChange.handleSubmit()}
              sx={{
                bgcolor: '#192873',
                color: '#FFFFFF',
                borderRadius: '12px',
                py: 1.4,
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 700,
                fontSize: '14px',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#B7102A',
                  boxShadow: '0 4px 12px rgba(183, 16, 42, 0.25)'
                }
              }}
            >
              {language === 'en' ? 'Confirm Password Change' : 'Confirmar Cambio de Contraseña'}
            </Button>
          </Box>
        </Box>
      </FormModal>

      <FormModal onClose={handleModifyEmailModal} open={openModifyEmailModal} title={language === 'en' ? 'Change Email Address' : 'Modificar Correo Electrónico'} maxWidth="xs" fullWidth>
        <Box sx={{ pt: 1, pb: 2 }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2, 
            mb: 3, 
            p: 2, 
            borderRadius: '12px', 
            bgcolor: darkMode ? 'rgba(255,255,255,0.05)' : '#F8FAFC', 
            border: '1px solid #E2E8F0' 
          }}>
            <Box sx={{ 
              width: 44, 
              height: 44, 
              borderRadius: '10px', 
              bgcolor: 'rgba(11, 130, 150, 0.08)', 
              color: '#0B8296', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center' 
            }}>
              <EmailIcon sx={{ fontSize: 24 }} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' ? 'Update Main Email Address' : 'Actualización de Correo Principal'}
              </Typography>
              <Typography variant="caption" sx={{ color: '#64748B', fontFamily: 'Roboto, sans-serif' }}>
                {language === 'en' 
                  ? 'Enter your new email address and verify with your current password.' 
                  : 'Ingrese la nueva dirección de correo y verifique con su contraseña actual.'}
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={2.5}>
            <Grid item xs={12} sm={6}>
              <TextField 
                title={language === 'en' ? 'New Email Address' : 'Nuevo Correo Electrónico'} 
                type="email" 
                id="email"
                value={formikEmailChange.values.email}
                onChange={formikEmailChange.handleChange}
                onBlur={formikEmailChange.handleBlur}
                error={formikEmailChange.touched.email && Boolean(formikEmailChange.errors.email)}
                helperText={formikEmailChange.touched.email && formikEmailChange.errors.email}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                title={language === 'en' ? 'Confirm New Email' : 'Repetir Nuevo Correo'} 
                type="email" 
                id="new_email_confirmation"
                value={formikEmailChange.values.new_email_confirmation}
                onChange={formikEmailChange.handleChange}
                onBlur={formikEmailChange.handleBlur}
                error={formikEmailChange.touched.new_email_confirmation && Boolean(formikEmailChange.errors.new_email_confirmation)}
                helperText={formikEmailChange.touched.new_email_confirmation && formikEmailChange.errors.new_email_confirmation}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                title={language === 'en' ? 'Current Password' : 'Contraseña Actual'} 
                type="password" 
                id="password"
                value={formikEmailChange.values.password}
                onChange={formikEmailChange.handleChange}
                onBlur={formikEmailChange.handleBlur}
                error={formikEmailChange.touched.password && Boolean(formikEmailChange.errors.password)}
                helperText={formikEmailChange.touched.password && formikEmailChange.errors.password}
                required
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => formikEmailChange.handleSubmit()}
              sx={{
                bgcolor: '#192873',
                color: '#FFFFFF',
                borderRadius: '12px',
                py: 1.4,
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 700,
                fontSize: '14px',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#B7102A',
                  boxShadow: '0 4px 12px rgba(183, 16, 42, 0.25)'
                }
              }}
            >
              {language === 'en' ? 'Confirm Email Change' : 'Confirmar Cambio de Correo'}
            </Button>
          </Box>
        </Box>
      </FormModal>

      {/* 2FA OTP Activation Verification Modal */}
      <FormModal 
        onClose={() => {
          setOpenOtpModal(false);
          setTwoFactorEnabled(false);
        }} 
        open={openOtpModal} 
        title="Activar Doble Factor (2FA)"
      >
        <SmallHeightDivider />
        <Box sx={{ p: 1, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              width: '64px', 
              height: '64px', 
              borderRadius: '50%', 
              backgroundColor: 'rgba(32, 42, 93, 0.05)', 
              border: '2px solid #202a5d' 
            }}>
              <SecurityIcon sx={{ fontSize: '32px', color: '#202a5d' }} />
            </Box>
          </Box>

          <Box sx={{ 
            bgcolor: '#F8FAFC', 
            border: '1px solid #E2E8F0', 
            borderRadius: '16px', 
            p: 3, 
            mb: 3, 
            textAlign: 'center' 
          }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 500, fontFamily: 'Roboto, sans-serif' }}>
              Para habilitar la verificación en dos pasos (2FA), enviaremos un código de seguridad OTP a su correo registrado:
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: darkMode ? '#ffffff' : '#192873', fontFamily: 'Roboto, sans-serif', letterSpacing: '0.5px' }}>
              {data?.payload?.email}
            </Typography>
          </Box>

          {!otpSent ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <StyledButton 
                onClick={handleSendOtp} 
                disabled={isSendingOtp}
                style={{ width: 'auto', minWidth: '220px', padding: '12px 24px', borderRadius: '10px' }}
              >
                {isSendingOtp ? 'ENVIANDO CÓDIGO...' : 'SOLICITAR CÓDIGO OTP'}
              </StyledButton>
            </Box>
          ) : (
            <Box sx={{ mt: 2 }}>
              <Grid container spacing={2} justifyContent="center" alignItems="center">
                <Grid item xs={12} sm={8}>
                  <TextField 
                    title="Código de Seguridad OTP" 
                    type="text" 
                    id="otpCode"
                    placeholder="Ej. 123456"
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value)}
                    required
                  />
                </Grid>
              </Grid>
              
              <MediumHeightDivider />
              <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 2 }}>
                <StyledButtonOutlined 
                  onClick={handleSendOtp} 
                  disabled={isSendingOtp}
                  style={{ width: 'auto', borderRadius: '10px', padding: '10px 20px' }}
                >
                  REENVIAR CÓDIGO
                </StyledButtonOutlined>
                <StyledButton 
                  onClick={handleVerifyOtp} 
                  disabled={isVerifyingOtp || !otpCode}
                  style={{ width: 'auto', borderRadius: '10px', padding: '10px 24px' }}
                >
                  {isVerifyingOtp ? 'VERIFICANDO...' : 'VERIFICAR Y ACTIVAR'}
                </StyledButton>
              </Box>
            </Box>
          )}

          {otpError && (
            <Box sx={{ mt: 2.5, bgcolor: '#FEF2F2', border: '1px solid #FCA5A5', borderRadius: '8px', p: 1.5 }}>
              <Typography variant="body2" color="error" sx={{ fontWeight: 'bold', fontFamily: 'Roboto, sans-serif', m: 0 }}>
                {otpError}
              </Typography>
            </Box>
          )}
        </Box>
        <SmallHeightDivider />
      </FormModal>
      <MediumHeightDivider />
    </Container>
  );
};
